import AlertBox from "../components/alertBox"
import { CSSTransition, TransitionGroup } from "react-transition-group"

import {
  INotification,
  closeNotification
} from "../containers/notificationSlice"
import { useAppDispatch, useAppSelector } from "./hooks"

const Notifications = () => {
  const notifications = useAppSelector(
    (state) => state["notificationReducer"].notifications
  )
  const dispatch = useAppDispatch()

  const handleClose = (id: string) => {
    dispatch(closeNotification(id))
  }

  return (
    <div className="ocs-notifications-container">
      <TransitionGroup component={null}>
        {notifications.map(
          (notification: INotification) =>
            notification.message.length > 0 && (
              <CSSTransition
                key={notification.id}
                classNames="notification-add"
                timeout={{ enter: 200, exit: 150 }}
              >
                <AlertBox
                  type={notification.kind}
                  message={notification.message}
                  onClose={() => handleClose(notification.id)}
                />
              </CSSTransition>
            )
        )}
      </TransitionGroup>
    </div>
  )
}

export default Notifications
